//Frontend/src/services/updateService.js
import api from './api';

// Helper function to convert Firestore timestamps to JavaScript Dates
const convertFirestoreTimestamp = (timestamp) => {
  if (timestamp && timestamp._seconds) {
    const milliseconds = timestamp._seconds * 1000 + Math.floor(timestamp._nanoseconds / 1000000);
    return new Date(milliseconds);
  }
  return timestamp;
};

// Helper function to process update data and convert dates
const processUpdateData = (data) => {
  if (Array.isArray(data)) {
    return data.map(item => ({
      ...item,
      date: convertFirestoreTimestamp(item.date),
      // Convert any other timestamp fields you might have
      created_at: convertFirestoreTimestamp(item.created_at),
      updated_at: convertFirestoreTimestamp(item.updated_at)
    }));
  } else {
    return {
      ...data,
      date: convertFirestoreTimestamp(data.date),
      created_at: convertFirestoreTimestamp(data.created_at),
      updated_at: convertFirestoreTimestamp(data.updated_at)
    };
  }
};

const updatesService = {
  getAllUpdates: async () => {
    try {
      const response = await api.get('/updates');
      return processUpdateData(response.data);
    } catch (error) {
      console.error('Error fetching updates:', error);
      throw error;
    }
  },

  getUpdateByMinistry: async (ministryId) => {
    try {
      const response = await api.get(`/ministry/${ministryId}`);
      return processUpdateData(response.data);
    } catch (error) {
      console.error(`Error fetching updates in ministry ${ministryId}:`, error);
      throw error;
    }
  },

  createUpdate: async (updateData) => {
    try {
      const response = await api.post('/updates', updateData);
      return processUpdateData(response.data);
    } catch (error) {
      console.error('Error creating update:', error);
      throw error;
    }
  },

  updateUpdate: async (id, updateData) => {
    try {
      const response = await api.put(`/updates/${id}`, updateData);
      return processUpdateData(response.data);
    } catch (error) {
      console.error(`Error updating update ${id}:`, error);
      throw error;
    }
  },

  deleteUpdate: async (id) => {
    try {
      const response = await api.delete(`/updates/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting update ${id}:`, error);
      throw error;
    }
  },

  getUpdateByName: async (name) => {
    try {
      const response = await api.get(`/updates/name/${name}`);
      return processUpdateData(response.data);
    } catch (error) {
      console.error(`Error fetching update by name ${name}:`, error);
      throw error;
    }
  }
};

export default updatesService;